import type { CityConfig } from "../city-template/types";

export const warwickConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Warwick",
  state: "Rhode Island",
  stateAbbr: "RI",
  slug: "warwick",
  route: "/warwick",
  title: "Emergency Passport Warwick, RI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Warwick, RI — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Warwick travelers, T.F. Green Airport passengers, Kent County families, and all Rhode Island communities.",
  h1: "Emergency & Expedited Passport Services in Warwick, RI",
  heroSubtitle: "Your T.F. Green flight to Orlando connects to an international departure and your passport's expired? Warwick family booking a first trip to Ireland and the kids need first-time passports? Kent Hospital professional heading to a medical conference in Geneva next week? We help Warwick residents — from Apponaug to Conimicut to Cowesett — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20T.F.%20Green%20International%20Airport%20in%20Warwick%20Rhode%20Island%20with%20modern%20terminal%20architecture%20and%20runway%20stretching%20toward%20Narragansett%20Bay%2C%20golden%20afternoon%20light%20on%20coastal%20New%20England%20landscape%2C%20professional%20aviation%20photography%20with%20soft%20clouds%20and%20rich%20warm%20tones%2C%20clean%20composition%20showcasing%20the%20airport%20as%20the%20travel%20hub%20of%20Rhode%20Island%2C%20no%20text%20overlay&width=1800&height=700&seq=warwick-hero-2026&orientation=landscape",
  heroImageAlt: "T.F. Green International Airport in Warwick Rhode Island with Narragansett Bay beyond",
  geoPosition: "41.7001;-71.4162",
  geoPlacename: "Warwick, Rhode Island",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St, Boston, MA 02222",
    distance: "Located in downtown Boston — approximately 55 miles from Warwick, appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Warwick", zips: "02886, 02887, 02888, 02889, 02818" },
    { name: "Providence", zips: "02901–02912, 02918, 02940" },
    { name: "Cranston", zips: "02905, 02906, 02907, 02910, 02920, 02921" },
    { name: "East Greenwich", zips: "02818" },
    { name: "North Kingstown", zips: "02852, 02874" },
    { name: "West Warwick", zips: "02893" },
    { name: "Coventry", zips: "02816, 02827" },
    { name: "Pawtucket", zips: "02860, 02861, 02862" },
    { name: "East Providence", zips: "02914, 02915, 02916" },
    { name: "Johnston", zips: "02919" },
    { name: "Bristol", zips: "02809" },
    { name: "Barrington", zips: "02806" },
    { name: "Newport", zips: "02840, 02841" },
    { name: "Narragansett", zips: "02882" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour PVD Airport Emergency Processing", desc: "Your T.F. Green flight is in two days and your passport is gone? Reserved courier access to the Boston Passport Agency — as fast as 24 hours for Warwick travelers with immediate departures." },
    { icon: "ri-flight-takeoff-line", title: "T.F. Green Airport Expertise", desc: "Rhode Island's primary airport is right here in Warwick. We know airline schedules, seasonal routes, and the unique passport urgencies that arise when you live next to an airport." },
    { icon: "ri-building-2-line", title: "Kent County Business & Medical Travel", desc: "Kent Hospital professionals, insurance industry employees, and Warwick small business owners with international meetings — we handle the passport while you handle the business." },
    { icon: "ri-anchor-line", title: "Coastal Rhode Island Family Expedited", desc: "Warwick families heading to Ireland, Italy, or the Caribbean — first-time passports, child passports, and renewals for your next family adventure across the Atlantic." },
  ],
  internalLinks: [
    { name: "Fast passport services in Providence, RI", route: "/providence" },
    { name: "Expedited passport in Cranston, RI", route: "/cranston" },
    { name: "Quick passport services in Pawtucket, RI", route: "/pawtucket" },
    { name: "Urgent passport services in Newport, RI", route: "/newport-ri" },
    { name: "Rhode Island passport services overview", route: "/states/rhode-island" },
  ],
  fpcOfficeAddress: "One Boston Place, Suite 2600, Boston, MA 02108",
  fpcOfficeNote: "Fast Passport Center serves Warwick via secure registered courier with direct access to the Boston Passport Agency at 10 Causeway St. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Warwick residents can ship from any UPS Store, FedEx Office, or post office location across the city and Kent County.",
  fpcOfficeDistance: "Serving Warwick, Cranston, Providence, East Greenwich, West Warwick, and all Kent County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Warwick and greater Kent County. From the Apponaug village center to Conimicut Point, from Cowesett to Hoxsie and Norwood — we serve every Warwick neighborhood. Our courier service eliminates the need to drive to Boston and wait for a passport agency appointment — and with T.F. Green Airport in your backyard, you have better things to do than sit in I-95 traffic.",
  nearbyCitiesIntro: "We serve Warwick and all surrounding Rhode Island communities including Providence, Cranston, East Greenwich, North Kingstown, West Warwick, Coventry, Pawtucket, East Providence, and Newport. We also serve T.F. Green Airport travelers who need emergency passport processing before international connections.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Warwick as simple as possible — with the speed and reliability airport-adjacent travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Warwick travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Warwick travelers encounter unique passport issues — from T.F. Green connection paperwork to international travel booked through connecting flights, to 6-month validity rules for European and Caribbean destinations. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Warwick travelers — from T.F. Green airport employees to Kent County families to Apponaug small business owners — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Warwick, RI? Here are the most common ones we hear from Kent County-area travelers.",
  statePageRoute: "/states/rhode-island",
  statePageName: "Rhode Island",
  servicesIntro: "Whether you need a renewal before a connecting international flight from T.F. Green, an emergency passport for a last-minute business trip, or a first-time passport for a Warwick family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ri.gov",
  dmvLabel: "Rhode Island DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "T.F. Green flight connecting to Europe in two days? International business meeting in London this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Warwick-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Warwick residents renew fast — no agency visit required for most renewals. Perfect for Kent County professionals, T.F. Green commuters, and Rhode Island families planning international trips.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Warwick residents through every step — from Apponaug to Conimicut to Cowesett — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your Warwick-to-international connecting itinerary or overseas business trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Warwick family trip abroad stays on schedule — whether to Ireland, Italy, or the Caribbean.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Warwick professionals navigating name changes before international business travel.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Warwick airport-adjacent professionals, Kent Hospital medical staff, and insurance executives who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Warwick-area travelers through the process so your international itinerary or connecting flight stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Warwick RI", description: "Urgent passport processing for Warwick Rhode Island travelers with immediate departure needs from T.F. Green Airport." },
    { name: "Expedited Passport Renewal Warwick RI", description: "Fast passport renewal for Warwick Rhode Island residents with a previously-issued passport." },
    { name: "First-Time Passport Warwick RI", description: "New passport application services for Warwick Rhode Island residents applying for their first passport." },
    { name: "Child Passport Warwick RI", description: "Minor passport services for Warwick Rhode Island families with children under 16." },
    { name: "Name Change Passport Warwick RI", description: "Passport name correction after marriage, divorce, or legal name changes for Warwick residents." },
    { name: "Second Passport Warwick RI", description: "Second passport services for Warwick frequent flyers, Kent County professionals, and international business travelers." },
  ],
  testimonials: [
    {
      name: "Michael D.",
      location: "Apponaug, Warwick",
      rating: 5,
      text: "Flying out of T.F. Green to connect through JFK to Dublin — realized my passport expired two weeks prior with just 6 days until departure. Fast Passport Center got it back in 4 days. The document review caught an error on my renewal form I'd completely missed.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The O'Brien Family",
      location: "Cowesett, Warwick",
      rating: 5,
      text: "Booked a family trip to Ireland — first international trip for our three kids. They walked us through every step of the child passport process and all five passports arrived in 5 days. The checklist made the acceptance clerk visits painless.",
      service: "Child Passports",
    },
    {
      name: "Jennifer K.",
      location: "Conimicut, Warwick",
      rating: 5,
      text: "Medical conference in Geneva came up with 10 days notice. Needed a name change on my passport after getting married. They handled everything remotely and I had my corrected passport before the hospital even finalized my travel arrangements.",
      service: "Name Change Passport",
    },
    {
      name: "Robert H.",
      location: "Norwood, Warwick",
      rating: 5,
      text: "Insurance industry conference in London booked last-minute. My passport was fine but my wife's had expired during COVID. Fast Passport Center renewed hers in 3 days — we both made the trip. Now we tell everyone in our Kent County office about this service.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "war-1",
      name: "Warwick Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "575 Sandy Ln",
      city: "Warwick",
      state: "RI",
      zip: "02889",
      phone: "(401) 737-8700",
      hours: "Mon–Fri 8:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Central Warwick",
      website: "https://tools.usps.com/find-location.htm?location=1378552",
      websiteLabel: "USPS Location",
      notes: "Main Warwick post office with Saturday appointments available — one of the few Rhode Island facilities with weekend hours. Passport photos on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "war-2",
      name: "Apponaug Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "33 S Main St",
      city: "Warwick",
      state: "RI",
      zip: "02886",
      phone: "(401) 737-3330",
      hours: "Mon–Fri 8:00 AM – 4:30 PM (appointment required)",
      distance: "Apponaug Village",
      website: "https://tools.usps.com/find-location.htm?location=1378538",
      websiteLabel: "USPS Location",
      notes: "Convenient for Apponaug residents and Kent County government employees. Passport photos available. Smaller facility — book appointments early during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "war-3",
      name: "Cranston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1055 Park Ave",
      city: "Cranston",
      state: "RI",
      zip: "02910",
      phone: "(401) 941-4340",
      hours: "Mon–Fri 8:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Cranston — bordering Warwick",
      website: "https://tools.usps.com/find-location.htm?location=1387611",
      websiteLabel: "USPS Location",
      notes: "Serves Cranston and northern Warwick neighborhoods. Saturday appointments available. Passport photos available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "war-4",
      name: "East Greenwich Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11 Main St",
      city: "East Greenwich",
      state: "RI",
      zip: "02818",
      phone: "(401) 884-4240",
      hours: "Mon–Fri 8:30 AM – 4:30 PM (appointment required)",
      distance: "East Greenwich — bordering Warwick",
      website: "https://tools.usps.com/find-location.htm?location=1373498",
      websiteLabel: "USPS Location",
      notes: "Serves East Greenwich and southern Warwick neighborhoods. Smaller facility with limited appointment slots — book at least a week in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "war-5",
      name: "Providence Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "24 Corliss St",
      city: "Providence",
      state: "RI",
      zip: "02904",
      phone: "(401) 276-2400",
      hours: "Mon–Fri 8:00 AM – 4:30 PM (appointment required)",
      distance: "Providence — 10 miles from Warwick",
      website: "https://tools.usps.com/find-location.htm?location=1368763",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in the region. Photo services on-site. Busiest facility in Rhode Island — book early, especially during study-abroad season.",
      icon: "ri-mail-line",
    },
    {
      id: "war-6",
      name: "Kent County Courthouse — Clerk's Office",
      type: "County Clerk Document Services",
      address: "222 Quaker Ln",
      city: "West Warwick",
      state: "RI",
      zip: "02893",
      phone: "(401) 822-6900",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      distance: "West Warwick — Kent County seat",
      website: "https://www.courts.ri.gov/",
      websiteLabel: "RI Judiciary",
      notes: "County-level document services for vital records and legal documents. For passport applications specifically, visit an authorized acceptance facility or post office.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Boston Passport Agency (55+ miles from Warwick)", fpc: "Most Warwick travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "PVD-Specific Guidance", agency: "Generic — no T.F. Green Airport, Kent County, or coastal RI expertise", fpc: "Full T.F. Green/Kent County/coastal RI knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming T.F. Green Handles International Flights Directly",
      description: "Most international travel from Warwick involves connecting through JFK, Newark, or Philadelphia. Your passport still must be valid at check-in at T.F. Green — not just at the international connection point. Many Warwick travelers do not realize this.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Driving to Boston Without an Appointment",
      description: "The Boston Passport Agency requires appointments even for emergencies. Many Kent County residents drive 55 miles to Boston only to be turned away. Our courier channel bypasses this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Warwick applicants often attempt the simpler renewal form when their passport was issued at age 15 or younger, or is more than 15 years old. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Stores",
      description: "Many Warwick CVS and Walgreens photos fail State Department standards — wrong head size, shadows, or off-white backgrounds. We catch this in review before it causes a rejection and delays your connecting flight.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for the 6-Month Passport Validity Rule",
      description: "Warwick families booking to Ireland, Italy, or the Caribbean often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately during document review.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home or office in Warwick." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Warwick clients ship from home or from a local UPS Store — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to Boston or wait at the Boston Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty, and you are ready for T.F. Green." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Warwick?", a: "We offer Warwick-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Warwick office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (like the Warwick Post Office on Sandy Lane), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Warwick address." },
    { q: "Where can I get a passport acceptance in Warwick?", a: "Warwick has acceptance facilities at the main Post Office on Sandy Lane, the Apponaug Post Office on South Main Street, and nearby facilities in Cranston, East Greenwich, and Providence. We maintain an updated list of Kent County facilities with hours, photo availability, and appointment options." },
    { q: "Can I get my passport at T.F. Green Airport?", a: "T.F. Green Airport does not have a passport acceptance or issuance facility on-site. However, the Warwick Post Office is just a short drive from the terminal. For expedited processing — especially before an international connection — our registered courier service is the fastest channel available." },
    { q: "What is the best price for expedited passport service in Warwick?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Warwick applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Warwick-specific checklist." },
    { q: "Can I get a passport photo in Warwick?", a: "Yes — many Warwick CVS, Walgreens, UPS Stores, and FedEx Office locations offer passport photos. The Warwick Post Office on Sandy Lane also offers photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I check my Warwick passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Warwick to final return shipping typically matches your chosen speed tier." },
    { q: "Is Warwick near a passport agency?", a: "The nearest passport agency is in Boston — approximately 55 miles from Warwick. However, it only serves travelers with life-or-death emergencies. For standard expedited needs — even urgent ones — our courier channel is faster and more accessible than driving to Boston for an agency appointment." },
    { q: "Can you help with passports for T.F. Green Airport travelers?", a: "Absolutely. T.F. Green is Rhode Island's primary airport and we regularly assist Warwick travelers with expedited passports for domestic-to-international connections. We understand the PVD route map and can coordinate timelines around your departure — whether you are connecting through JFK, Newark, or Philadelphia." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Warwick Residents",
    intro: "Warwick's unique position as the home of Rhode Island's primary airport creates distinct passport timing challenges. Here's what Warwick travelers — especially those near T.F. Green — need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "PVD — T.F. Green Airport in Your Backyard",
        subtitle: "Rhode Island's primary airport, located right in Warwick",
        description: "T.F. Green handles more than 4 million passengers annually and serves as Rhode Island's gateway to the world. While primarily a domestic airport, PVD connects Warwick residents to international hubs like JFK, Newark, Philadelphia, and Baltimore — where international flights depart. The proximity of the airport creates a unique dynamic: Warwick residents can be at the terminal in 10 minutes, making last-minute travel extremely tempting — and extremely risky if your passport is not valid.",
        tip: "Living next to T.F. Green means you can book flights on short notice. But an expired passport cannot be solved at the check-in counter. Check your passport validity the moment you book — not the night before your flight.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "BOS — Logan International Airport",
        subtitle: "Boston Logan, primary international gateway for Rhode Island",
        description: "Logan is about 55 miles from Warwick via I-95 and handles direct flights to London, Paris, Dublin, Tokyo, and 80+ international destinations. For Warwick residents, Logan is the go-to for direct international flights — no connection needed. The drive is manageable but traffic on I-95 through Providence can turn a 55-mile trip into 2+ hours, especially during rush hour or summer beach traffic heading to Cape Cod.",
        tip: "If you are driving from Warwick to Logan for an international flight, factor in I-95 Providence traffic when calculating your passport appointment window. Better yet, avoid the agency visit entirely with our courier service.",
      },
      {
        icon: "ri-anchor-line",
        title: "Coastal & Narragansett Bay Travel Culture",
        subtitle: "Warwick's 39 miles of coastline and marine heritage",
        description: "Warwick's identity as a coastal city with deep ties to Narragansett Bay shapes its travel patterns. Boating families who spend summers on the Bay often take winter trips to the Caribbean or Mediterranean. The seasonal rhythm — summer on the water, winter abroad — means a predictable surge of passport needs in September and October as Warwick families plan winter getaways. The passport card is especially popular among Warwick's boating community for Canada and Caribbean crossings.",
        tip: "If you are a boater or frequent Caribbean traveler, consider the passport card as a supplement to your book passport. We can process both simultaneously through our courier channel.",
      },
      {
        icon: "ri-building-2-line",
        title: "Kent County Business & Medical Travel",
        subtitle: "Kent Hospital, insurance industry, small business",
        description: "Warwick's economy centers on healthcare (Kent Hospital is one of Rhode Island's largest employers), insurance, and retail. Medical professionals travel internationally for conferences, training, and mission trips. Insurance executives attend London and Bermuda meetings. Small business owners — from Apponaug shops to airport-area services — travel for trade shows and supplier visits. When these trips materialize on 1–2 weeks notice, standard post office processing is not fast enough.",
        tip: "Medical conference and insurance industry travel dates are typically fixed and unmovable. We recommend starting the passport process the moment your conference registration is confirmed — not when travel arranges your flight.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Warwick & the Ireland Connection",
      description: "Rhode Island has one of the highest percentages of Irish-American residents in the country, and Warwick is at the heart of that heritage. Family trips to Ireland — for weddings, heritage tours, and visiting relatives — are a year-round constant. These trips often involve multi-generational families traveling together, meaning first-time child passports, renewal of long-expired passports, and last-minute bookings when a family event comes up.",
    },
  },
  destinations: {
    title: "Where Warwick Travelers Go — And Why Passports Get Urgent",
    intro: "Warwick's airport-adjacent location, coastal heritage, and Kent County business community create unique international travel patterns. Here are the most common destinations and the urgency patterns we see.",
    stats: [
      { stat: "35%", label: "of Warwick expedited requests are for connecting international flights from T.F. Green — with under 2 weeks notice" },
      { stat: "2–3 Weeks", label: "average lead time Warwick travelers have from trip booking to international departure" },
      { stat: "Sep–Nov", label: "peak season when Warwick families book winter Caribbean and European getaways after summer boating season ends" },
      { stat: "48 Hours", label: "shortest turnaround we have accommodated for a Warwick traveler with a connecting T.F. Green-to-Dublin itinerary" },
    ],
    destinations: [
      { name: "Ireland", context: "Strong Irish-American heritage in Warwick and across Rhode Island — family reunions, weddings, heritage tours, and ancestral research trips", urgency: "Family events have fixed dates — bookings often 2–3 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "Large Italian-American community in Warwick and Kent County — family visits, heritage travel, summer vacations to Rome and Sicily", urgency: "Summer vacation bookings cluster in March–May with passport panic in April", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "London business meetings for insurance industry, academic conferences, family heritage trips — direct Logan flights make this a Warwick staple", urgency: "Business travel booked 1–2 weeks out with fixed meeting dates", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Bahamas", context: "Winter escape from New England cold — Dominican Republic, Jamaica, Bahamas resort packages and cruise departures", urgency: "Last-minute all-inclusive deals booked 2–4 weeks out during winter months", icon: "ri-map-pin-2-line" },
      { name: "France", context: "Paris for business and leisure, Normandy for heritage tourism, connecting through JFK or Logan", urgency: "Spring and fall shoulder-season bookings with 3–4 week planning windows", icon: "ri-map-pin-2-line" },
      { name: "Portugal", context: "Strong Portuguese-American community in Rhode Island — family visits to Lisbon, the Azores, and Madeira, community festivals and heritage events", urgency: "Festival dates and family events are fixed — bookings 3–4 weeks out", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Rhode Island Service Areas",
    crossLinksDesc: "We serve travelers across the Ocean State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Providence", route: "/providence" },
      { name: "Cranston", route: "/cranston" },
      { name: "Pawtucket", route: "/pawtucket" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Warwick", address: "849 W Shore Rd, Warwick, RI 02889", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Warwick", address: "1845 Post Rd, Warwick, RI 02886", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "The UPS Store — Warwick", address: "1243 Warwick Ave, Warwick, RI 02888", hours: "Mon–Fri 9 AM – 7 PM, Sat 10 AM – 4 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "FedEx Office — Warwick", address: "300 Quaker Ln, Warwick, RI 02886", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 10 AM – 6 PM", website: "https://www.office.fedex.com/default/office" },
    { name: "Walmart — Warwick", address: "650 Bald Hill Rd, Warwick, RI 02886", hours: "Daily 7 AM – 10 PM", website: "https://www.walmart.com/cp/photo/1078904" },
    { name: "CVS Pharmacy — Airport Area", address: "1000 Bald Hill Rd, Warwick, RI 02886", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Apponaug", address: "2191 Post Rd, Warwick, RI 02886", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Warwick Post Office Photos", address: "575 Sandy Ln, Warwick, RI 02889", hours: "Mon–Fri 8 AM – 4:30 PM, Sat 9 AM – 12 PM", website: "https://tools.usps.com/find-location.htm" },
  ],
  dmvLocations: [
    {
      name: "RI DMV — Cranston",
      address: "600 New London Ave, Cranston, RI 02920",
      hours: "Mon–Fri, 8:30 AM – 3:15 PM",
      note: "Main Rhode Island DMV office — driver licenses, REAL ID, vehicle registration. Just 5 minutes from Warwick. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "AAA Warwick",
      address: "1276 Bald Hill Rd, Warwick, RI 02886",
      hours: "Mon–Fri, 9:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      note: "AAA members can access limited DMV services including license renewals and REAL ID. Convenient Bald Hill Road location.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PVD",
      name: "T.F. Green Airport",
      distance: "Located in Warwick — minutes from anywhere in the city",
      address: "2000 Post Rd, Warwick, RI 02886",
      note: "Rhode Island's primary airport, located right in Warwick. Serves domestic destinations with connecting international service. Warwick residents can be at the terminal in 10 minutes or less.",
      flightUrl: "https://www.pvdairport.com/",
      flightLabel: "T.F. Green Airport Website",
      featured: true,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "About 55 miles from Warwick",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and worldwide destinations. Warwick travelers primarily use Logan for direct international flights — accessible via I-95 or Amtrak from Providence.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan International Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Rhode Island Department of Health. Online, mail, or in-person options available for Kent County residents.",
      url: "https://health.ri.gov/records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the RI Department of Health Vital Records office. Required for estate and legal matters in Kent County.",
      url: "https://health.ri.gov/records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Warwick City Clerk. Certified copies available for name changes and legal purposes across Kent County.",
      url: "https://www.warwickri.gov/city-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Rhode Island Family Court — Kent County. Required for name change passport corrections and legal documentation.",
      url: "https://www.courts.ri.gov/family/",
    },
  ],
};

export default warwickConfig;